var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        title: _vm.$t("ACCOUNT_BILLING_ADD_FUNDS_HEADER"),
        "show-confirm-button": false,
        "show-cancel-button": false,
        "custom-classes": "add-funds-modal",
        "allow-modal-to-be-closed": false
      },
      on: { close: _vm.closeModal }
    },
    [_c("AddFundsForm", { on: { cancel: _vm.closeModal } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }